import VoucherPrint from './voucher'

import VoucherPrintContent from './voucher/PrintContent'
import PreviewVoucher from './voucher/PreviewVoucher';

const routes: IRoute[] = [
  {
    path: '/pos/voucher/:id',
    component: VoucherPrint,
    layout: 'public',
    name: '查看单据',
  },
  {
    path: '/fdd/voucher/:id',
    component: VoucherPrint,
    layout: 'public',
    name: '查看单据',
  },
  {
    path: '/pos/previewVoucher/:id',
    component: PreviewVoucher,
    layout: 'public',
    name: '预览单据',
  },
  {
    path: '/pos/voucher_print/print',
    component: VoucherPrintContent,
    layout: 'public',
    name: '查看单据',
  },

]

export default routes



// WEBPACK FOOTER //
// ./src/page/interface/index.tsx